import React, { useEffect } from 'react';
import './bubbleAlert.css';

interface BubbleAlertProps {
  message: string;
  type?: 'error' | 'success' | 'info';
  onClose?: () => void;
  durationMs?: number;
}

const BubbleAlert: React.FC<BubbleAlertProps> = ({ message, type = 'error', onClose, durationMs = 5000 }) => {
  useEffect(() => {
    const t = setTimeout(() => {
      onClose?.();
    }, durationMs);
    return () => clearTimeout(t);
  }, [onClose, durationMs]);

  // allow keyboard closing via Escape
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose?.();
    }
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className={`bubble-alert bubble-${type}`} role="alert" onClick={onClose}>
      <div className="bubble-content">{message}</div>
      <button className="bubble-close" aria-label="close" onClick={onClose}>�</button>
    </div>
  );
};

export default BubbleAlert;